import React, { useState, useEffect, useCallback } from 'react';
import { ChevronUp, ChevronDown } from 'lucide-react';

export default function FloatingScrollButtons({ containerRef }) {
  const [showUp, setShowUp] = useState(false);
  const [showDown, setShowDown] = useState(false);

  const checkScroll = useCallback(() => {
    const el = containerRef?.current;
    if (!el) return;
    setShowUp(el.scrollTop > 200);
    setShowDown(el.scrollTop < el.scrollHeight - el.clientHeight - 200);
  }, [containerRef]);

  useEffect(() => {
    const el = containerRef?.current;
    if (!el) return;
    el.addEventListener('scroll', checkScroll);
    checkScroll();
    return () => el.removeEventListener('scroll', checkScroll);
  }, [containerRef, checkScroll]);

  const scrollTo = (dir) => {
    const el = containerRef?.current;
    if (!el) return;
    el.scrollTo({ top: dir === 'top' ? 0 : el.scrollHeight, behavior: 'smooth' });
  };

  return (
    <div className="fixed bottom-6 right-6 flex flex-col gap-2 z-30">
      {showUp && (
        <button
          onClick={() => scrollTo('top')}
          className="w-10 h-10 rounded-full bg-navy text-white shadow-lg flex items-center justify-center hover:bg-navy-light transition-colors"
        >
          <ChevronUp className="w-5 h-5" />
        </button>
      )}
      {showDown && (
        <button
          onClick={() => scrollTo('bottom')}
          className="w-10 h-10 rounded-full bg-navy text-white shadow-lg flex items-center justify-center hover:bg-navy-light transition-colors"
        >
          <ChevronDown className="w-5 h-5" />
        </button>
      )}
    </div>
  );
}